const fever=[

    {
    label:"Maximum Temperature (C)",
    controlType:"number",
    options:[]
    },
    {
    label:"When present",
    controlType:"radio button",
    options:["Constant","Intermittent"]
    },

{
    label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Occasionally"]
    },
    

    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    

]

export default fever